/* eslint eqeqeq: 0 */
import { SET_CLOSE_MENU } from "../constants/wrapper";

export default function closeMenu(state = false, action) {
  if (action.type == SET_CLOSE_MENU) {
    return action.close;
  }
  return state;
}
